"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var RawExampleCard_1 = require("./RawExampleCard");
var TitleAndContentExampleCard_1 = require("./TitleAndContentExampleCard");
var StylingExampleCard_1 = require("./StylingExampleCard");
var ImageExampleCard_1 = require("./ImageExampleCard");
var PropertiesCard_1 = require("./PropertiesCard");
exports.ComponentCardPage = function () { return (React.createElement(common_1.Page, { headerText: "Card" },
    React.createElement(common_1.Paragraph, null, "Card is a nice place to put some compact info."),
    React.createElement(common_1.TopicHeader, null, "Examples"),
    React.createElement(RawExampleCard_1.RawExampleCard, null),
    React.createElement(TitleAndContentExampleCard_1.TitleAndContentExampleCard, null),
    React.createElement(StylingExampleCard_1.StylingExampleCard, null),
    React.createElement(ImageExampleCard_1.ImageExampleCard, null),
    React.createElement(common_1.TopicHeader, null, "Properties"),
    React.createElement(PropertiesCard_1.PropertiesCard, null))); };
exports.ComponentCardPage.displayName = 'ComponentCardPage';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentCardPage/ComponentCardPage.tsx
// module id = 640
// module chunks = 0